var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.funnel = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }
    setTimeout(function () {
        widget.find('.loading-box').hide();
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var container = $('<div class="funnel">').css({ width: '90%', height: '90%', top: '5%', left: '5%' }); 

        var keys = MDB.Charts.getDataKeys(data[0]);
        var values = data || 0;
        var kendoConfig = {
            legend: {
                visible: false
            },
            chartArea: {
                height: MDB.Charts.calculateKendoChartMaxHeight(widget) 
            },
            series: [
                {
                    type: "funnel",
                    name: keys[1],
                    categoryField: keys[0],
                    field: keys[1],
                    data: values,
                    labels: {
                        visible: true,
                        color: "white"
                    }
                }
            ],
            tooltip: {
                visible: true,
                template: "#= category #"
            }
        };
        $.extend(true, kendoConfig, metadata.KendoConfig);

        chart.append(container);
        container.kendoChart(kendoConfig);

    }, 0);
};